import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import User from 'models/user/user.model';
import { UserService } from 'services/user/user.service';
import { OrganizationUnitService } from 'services/organization-unit/organization-unit.service';
import { ProjectService } from 'services/project/project.service';

@Component({
  selector: 'app-organization-unit-list',
  templateUrl: './organization-unit-list.component.html',
  styleUrls: ['./organization-unit-list.component.scss'],
})
export class OrganizationUnitListComponent implements OnInit, OnDestroy {
  public ouList: OrganizationUnit[] = [];
  public user: User = new User();
  
  private ouListSubscription: Subscription;
  private userSubscription: Subscription;
  
  constructor(
    public userService: UserService,
    public projectService: ProjectService,
    public router: Router,
    public organizationUnitService: OrganizationUnitService,
  ) { }

  async ngOnInit() {
    this.ouListSubscription = this.organizationUnitService.getOuList().subscribe((list) => this.ouList = list);
    this.userSubscription = this.userService.getCurrentUser().subscribe((user) => this.user = user);
    await this.organizationUnitService.list();
  }
  
  get(ou: OrganizationUnit) {
    this.router.navigate([`/ou/get/${ou.id}`]);
  }

  ngOnDestroy() {
    if (this.ouListSubscription) {
      this.ouListSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}
